import { render, staticRenderFns } from "./text-numeric.vue?vue&type=template&id=1f8b419d&scoped=true&"
import script from "./text-numeric.vue?vue&type=script&lang=js&"
export * from "./text-numeric.vue?vue&type=script&lang=js&"
import style0 from "./text-numeric.vue?vue&type=style&index=0&id=1f8b419d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b419d",
  null
  
)

component.options.__file = "text-numeric.vue"
export default component.exports